import { Button, Input, DatePicker } from 'antd';
import { useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Moment } from 'moment';
import styled from 'styled-components';

const { RangePicker } = DatePicker;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0.4rem;

  .ant-btn:first-of-type {
    margin-right: 8px;
  }
`;

interface SearchBarProps {
  placeholder: string;
  searchFunction: (value: string | number | [Moment, Moment] | null | undefined) => void;
  clearFilters?: () => void;
  optionalClearFilter?: () => void;
  confirm?: () => void;
  range?: boolean;
  defaultValue?: string;
}

export const SearchBar = ({
  placeholder,
  searchFunction,
  clearFilters,
  confirm,
  range,
  defaultValue,
  optionalClearFilter,
}: SearchBarProps) => {
  const [searchText, setSearchText] = useState<string | number | [Moment, Moment] | null | undefined>();
  return (
    <div style={{ padding: 8 }}>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          if (searchText) {
            searchFunction(searchText);
          }

          if (confirm) {
            confirm();
          }
        }}
      >
        {range ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <RangePicker
              value={searchText as [Moment, Moment] | null | undefined}
              size="small"
              onChange={(dates) => {
                if (dates && dates[0] && dates[1]) {
                  setSearchText([dates[0], dates[1]]);
                }
              }}
            />
            <ButtonContainer>
              <Button block type="primary" icon={<SearchOutlined />} size="small" htmlType="submit">
                Search
              </Button>
              <Button
                block
                size="small"
                onClick={() => {
                  searchFunction([] as unknown as undefined);
                  setSearchText([] as unknown as undefined);

                  if (clearFilters) {
                    clearFilters();
                  }
                }}
              >
                Reset
              </Button>
            </ButtonContainer>
          </div>
        ) : (
          <>
            <Input
              placeholder={placeholder}
              value={searchText as string}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
              defaultValue={defaultValue}
            />
            <Button
              type="primary"
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90, marginRight: 8 }}
              htmlType="submit"
            >
              Search
            </Button>
            <Button
              size="small"
              style={{ width: 90 }}
              onClick={() => {
                searchFunction('');
                setSearchText('');

                if (clearFilters) {
                  clearFilters();
                }
                if (optionalClearFilter) {
                  optionalClearFilter();
                }
              }}
            >
              Reset
            </Button>
          </>
        )}
      </form>
    </div>
  );
};
